import React from "react";
import AccountIconImg from "./images/my-account.svg";

interface MyAccountIconProps {
  onClick?: () => void;
}

const MyAccountIcon: React.FunctionComponent<MyAccountIconProps> = ({ onClick }) => {
  const iconStyle: React.CSSProperties = {
    width: "44px",
    height: "44px",
    cursor: "pointer",
    transition: "opacity 0.3s ease-in-out",
    opacity: 1,
  };

  return (
    <div
      onClick={onClick}
      style={iconStyle}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <img src={AccountIconImg} alt="My Account" style={{ width: "100%", height: "100%" }} />
    </div>
  );
};

export default MyAccountIcon;
